// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__22piz","disabled":"FileBtn_disabled__tNg1A","warn":"FileBtn_warn__2Rq54","fade":"FileBtn_fade__2ggsZ"};